export default {
  Uni: 1,
  Studierende: 2,
  BR: 3,
  Zfsl: 4,
  Seminar: 5,
  Schule: 6,
  Ministerium: 7,
};
